// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2E3Vo","title":"ClientReferral_title__2Ngnv","itemText":"ClientReferral_itemText__S2m9_"};